import React, { Fragment, useState } from "react";
import { Link, withRouter, Redirect } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import {
  addRecentSearch,
  getRecentsearch,
  getRecentProducts,
} from "../../utils/storage";
import "react-toastify/dist/ReactToastify.css";
import Autosuggest from "react-autosuggest";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
// Redux
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { logout } from "../../actions/auth";
import { getCart, cartRemove } from "../../actions/cart";
import { currentLocation } from "../../actions/currentlocation";

const getSuggestionValue = (suggestion) => {
  return suggestion.name ? suggestion.name : suggestion.title;
};

const renderSuggestion = (suggestion) => {
  return <span>{suggestion.name ? suggestion.name : suggestion.title}</span>;
};

function renderSectionTitle(section) {
  return null;
}

// first row

export const FirstRow = () => {
  const [show, setShow] = useState(false);
  const [firstRowH, setfirstRowH] = useState(true);
  const _handleShow = () => {
    setShow(true);
  };
  const handleClose = () => {
    setShow(false);
  };
  const megaLinkClicked = () => {
    setfirstRowH(false);
  };
  return (
    <>
      <div className="d-flex bg-dark-gray wrapper-90 small-w100">
        <div className="wrapper addJustOnLp top-heading">
          <div className="top-first-heading">
            <span style={{ color: "#fff" }}>
              <Link
                to="/category/furniture"
                onMouseOver={megaLinkClicked}
                className="d-flex align-center"
              >
                Home Improvement Projects, Done Your Way | Shop Updates
                <svg
                  focusable="false"
                  viewBox="0 0 28 28"
                  style={{
                    fill: "#ffffff",
                    width: "28px",
                    height: "28px",
                  }}
                  data-enzyme-id="SitewideBannerIcon"
                  class="pl-BaseIcon SitewideBanner-ctaIcon"
                  aria-hidden="true"
                  data-hb-id="pl-icon"
                >
                  <path d="M21.22 14.826a.79.79 0 00.2-.31.842.842 0 00.07-.35v-.03a.842.842 0 00-.07-.35.79.79 0 00-.2-.31l-3.17-3.18a1 1 0 00-1.42 1.41l1.46 1.43H7a1 1 0 000 2h11.09l-1.47 1.48a1 1 0 101.42 1.41l3.17-3.18.01-.02z"></path>
                </svg>
              </Link>
            </span>
          </div>
        </div>
        <div className="top-right-btn">
          <Link to="" onClick={_handleShow}>
            <span className="small-hidden">FREE Shipping Over $49*</span>
            <span className="small-shown px-3">
              Home Improvement Projects, Done Your Way | Shop Updates
            </span>
          </Link>
        </div>
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        className="shipping-modal"
        style={{ marginTop: "12vh", boxShadow: "none" }}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-center">
            Free shipping over $49{" "}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive">
            <div className="membership-pricing-table">
              <div className="products">
                <div className="container">
                  <div className="row text-center">
                    <div className="col-md-4 col-sm-6">
                      <div className="product-content">
                        <div className="header-popup-icons">
                          <LazyLoadImage
                            effect="blur"
                            src="https://sundialinsider.s3.us-east-2.amazonaws.com/276truck.png"
                            width="50%"
                            alt=""
                          />
                        </div>
                        <p>
                          FREE Shipping over $49 and $4.99 flat-rate shipping
                          for orders under $49
                        </p>
                      </div>
                    </div>
                    <div className="col-md-4 col-sm-6">
                      <div className="product-content">
                        <div className="header-popup-icons">
                          <LazyLoadImage
                            effect="blur"
                            src="https://sundialinsider.s3.us-east-2.amazonaws.com/310calendar.png"
                            width="50%"
                            alt=""
                          />
                        </div>
                        <p>
                          EASY returns on most orders if something's not quite
                          right
                        </p>
                      </div>
                    </div>
                    <div className="col-md-4 col-sm-6">
                      <div className="product-content">
                        <div className="header-popup-icons">
                          <LazyLoadImage
                            effect="blur"
                            src="https://sundialinsider.s3.us-east-2.amazonaws.com/532order.png"
                            width="50%"
                            alt=""
                          />
                        </div>
                        <p>
                          FAST 2-day shipping on thousands of items—from
                          toasters to towel racks
                        </p>
                      </div>
                    </div>
                  </div>
                  <p className="text-center">
                    *Free shipping is only available in the contiguous U.S. Some
                    exclusions apply, including flooring, large fixtures, and
                    non-standard items. Sundial Home Products reserves the right
                    to change this offer at any time. Read more on shipping
                    policy or return policy.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

function getSuggestions(value) {
  return value
    .map((section) => {
      console.log();
      // console.log(
      //   section.data.filter((data) => (data.title ? data.title : data.name))
      // );
      return {
        title: section.title,
        data:
          section.data &&
          section.data.filter((data1) =>
            data1.title ? data1.title : data1.name
          ),
      };
    })
    .filter((section) => section.data.length > 0);
}
function getSectionSuggestions(section) {
  return section.data;
}

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cart: [],
      boxShadow: false,
      userPopup: false,
      wishPopup: false,
      cartPopup: false,
      total: "",
      query: "",
      value: "",
      megaMenueOpen: false,
      suggestions: [],

      bar: false,
      hover: false,
      close: false,
      redirect: false,
    };
  }

  viewLinkClicked = () => {
    this.setState({
      bar: false,
    });
  };

  addBoxShadow = () => {
    this.setState({
      boxShadow: true,
      userPopup: true,
    });
  };
  hideUserPopup = () => {
    this.setState({
      userPopup: false,
      boxShadow: false,
    });
  };
  showCartPopup = () => {
    this.setState({
      boxShadow: true,
      cartPopup: true,
    });
  };
  hideCartPopup = () => {
    this.setState({
      boxShadow: false,
      cartPopup: false,
    });
  };

  showWishBox = () => {
    this.setState({
      boxShadow: true,
      wishPopup: true,
    });
  };
  hideWishBox = () => {
    this.setState({
      boxShadow: false,
      wishPopup: false,
    });
  };

  remBoxShadow = () => {
    this.setState({
      userPopup: false,
      boxShadow: false,
      cartPopup: false,
    });
  };

  getBaar = (check, bar, hover) => {
    return check === "" &&
      bar === true &&
      (getRecentProducts().length > 0 || getRecentsearch().length > 0) ? (
      <div
        onMouseEnter={() => this.setState({ hover: true })}
        onMouseLeave={() => this.setState({ hover: false })}
        className="search-sug"
      >
        <div className="recentView-search">
          <div className="searchV-header">
            <div className="d-flex justify-between align-center">
              <p className="mb-0 adjustedFont">Recently Viewed</p>
              <Link
                onClick={this.viewLinkClicked}
                to="/recently-view"
                className="txt-decrate txt-underline font-small line-20 default-color"
              >
                View All
              </Link>
            </div>

            <div className="d-flex align-center justify-between recentCards">
              {/*   console.log(getRecentProducts()[0]['image']) */}
              {getRecentProducts().length > 0 &&
                getRecentProducts().map((k, i) => {
                  var str = k["name"];
                  var res = str.substring(0, 20);
                  return i < 4 ? (
                    <Link
                      to={`/product/${k["slug"]}`}
                      onClick={() => {
                        window.location.assign(`/product/${k["slug"]}`);
                        this.setState({ bar: false, hover: false });
                      }}
                      className="recentCard"
                    >
                      <div className="recentCard-img">
                        <div
                          style={{
                            background: `url(${k["image"]}`,
                            backgroundSize: "contain",
                            backgroundPosition: "center",
                            height: "100%",
                            backgroundRepeat: "no-repeat",
                          }}
                        ></div>
                      </div>
                      <div className="recentCard-txt">
                        <span>{res}..</span>
                      </div>
                    </Link>
                  ) : null;
                })}
            </div>
          </div>
          <div className="recent-searchesLinks-container m-1">
            <div className="recentTitle">
              <span>Recently Search</span>
            </div>
            <div className="searchesLinks">
              {getRecentsearch().length > 0 &&
                getRecentsearch().map((k, i) => {
                  return (
                    <Link
                      to={`/search/${k}`}
                      onClick={() => {
                        this.setState({ bar: false, hover: false });
                      }}
                      className="recentSearch-link"
                    >
                      <span>{k}</span>
                    </Link>
                  );
                })}

              {/*    <Link to="#" className="recentSearch-link">
            <span>blue</span>
          </Link>
          <Link to="#" className="recentSearch-link">
            <span>white table</span>
          </Link>
          <Link to="#" className="recentSearch-link">
            <span>green table</span>
          </Link>
          <Link to="#" className="recentSearch-link">
            <span>yellow table</span>
          </Link>
          <Link to="#" className="recentSearch-link">
            <span>red table</span>
          </Link> */}
            </div>
          </div>
        </div>
      </div>
    ) : null;
  };
  componentDidMount() {
    // setInterval(async () => {
    //   const res = this.props.getCart();
    //   this.setState({
    //     cart: JSON.parse(
    //       localStorage.getItem("cart") && localStorage.getItem("cart")
    //     ),
    //   });
    //   const priceArr = [];

    //   var total = 0;
    //   for (var i in priceArr) {
    //     total += priceArr[i];
    //   }

    //   this.setState({ total: total });

    //   if (!res) {
    //     this.setState({ cart: [] });
    //   }
    // }, 1000);
    this.props.currentLocation();
    const s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;

    // document.body.appendChild(s);
  }
  onChange = (event, { newValue, method }) => {
    // console.log(newValue);
    this.setState({ value: newValue, query: newValue });
  };

  onSuggestionsFetchRequested = async ({ value }) => {
    // if (value.length > 1) {

    let headers = { "Content-Type": "application/json" };
    const body = { search: value };
    const result = await fetch(
      `https://sundialhome.herokuapp.com/api/search/`,
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify(body),
      }
    );
    const content = await result.json();
    this.setState({ suggestions: getSuggestions(content) });
    // }
  };

  onSuggestionsClearRequested = () => {
    this.setState({ suggestions: [] });
  };
  removeCartItem = (index) => {
    const cartArr = JSON.parse(localStorage.getItem("cart"));
    cartArr.splice(index, 1);
    localStorage.setItem("cart", JSON.stringify(cartArr));
    this.props.cartRemove(cartArr);
    this.setState({ ...this.state });
  };
  onKeyPress = (e) => {
    if (e.key === "Enter") {
      if (this.state.query.length > 0) {
        this.props.history.push(`/search/${this.state.query}`);
      } else {
        toast(`Please enter a value`, { containerId: "B" });
      }
    }
  };
  clearSearch = () => {
    this.setState({ value: "", bar: false, hover: false });
  };

  _handleClose = () => {
    this.setState({ show: false });
  };

  hovered = () => {
    this.setState({
      megaMenueOpen: true,
    });
  };
  CloseMegaMenu = () => {
    this.setState({
      megaMenueOpen: false,
    });
  };

  focus = (e) => {
    e.target.placeholder = "";

    this.setState({ bar: true, close: true });
  };
  focusOut = (e) => {
    e.target.placeholder = "Find anything home...";
    if (this.state.hover === false) {
      this.setState({ bar: false });
    }
    if (this.state.value === "") {
      this.setState({ close: false });
    }
  };

  onSuggestionSelected = (
    event,
    { suggestion, suggestionValue, index, method }
  ) => {
    event.preventDefault();
    window.location.assign(`/search/${suggestion.name}`);
  };

  render() {
    const noHeader = this.props.location.pathname;

    const { isAuth, user } = this.props._auth;
    const {
      mainCategories,
      childCategories,
      subCategories,
    } = this.props._categories;
    const { value, suggestions } = this.state;
    const inputProps = {
      placeholder: "Find anything home...",
      value,
      onChange: this.onChange,
      name: "textBoxValue",
      onKeyPress: this.onKeyPress,
      onFocus: this.focus,
      onBlur: this.focusOut,

      required: true,
    };

    return noHeader === "/checkout" ? null : (
      <React.Fragment>
        {this.props.location.pathname === "/" ? <FirstRow /> : null}

        <header id="header" className="wrapper-90">
          <ToastContainer
            enableMultiContainer
            containerId={"B"}
            position={toast.POSITION.TOP_RIGHT}
          />
          {/*- TOP HEADING END*/}
          {/* FIRST NAV BAR */}
          <div className="navbar-top wrapper container-fluid px-0">
            <nav className="navbar navbar-expand" id="first-nav">
              <button
                className="navbar-toggler"
                type="button"
                hidden="true"
                data-toggle="collapse"
                data-target="#navbarTogglerDemo01"
                aria-controls="navbarTogglerDemo01"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon" id="hamb">
                  <span />
                  <span />
                  <span />
                </span>
              </button>
              {/* Logo */}
              <strong className="logoStrong">
                <Link className="navbar-brand" to="/" id="logo" title="Sundial">
                  <img src="https://sundialinsider.s3.us-east-2.amazonaws.com/54logo.png" />
                  {/* <LazyLoadImage
                effect="blur"
                src="https://sundialinsider.s3.us-east-2.amazonaws.com/54logo.png"
                alt=""
              /> */}
                </Link>
                <br />
              </strong>
              {/* FIRST NAV LINKS */}
              <div
                className="collapse navbar-collapse"
                id="navbarTogglerDemo01"
              >
                <div
                  className="collapse navbar-collapse"
                  id="navbarTogglerDemo01"
                >
                  <div
                    className="navigation-bar d-flex justify-content-between"
                    id="myHeader"
                  >
                    <ul className="first-nav-list first-searchbar">
                      <div className="hovershop hideSm d-flex align-center">
                        {/*  <li className="favi-img">
                      <LazyLoadImage
                        effect="blur"
                        src="/assets/images/favicon.png"
                        height="40px"
                        alt=""
                      />
                    </li> */}
                        <li id="shop-department">
                          <div className="shop-departments-link">
                            <span
                              className="d-flex align-center"
                              style={{ whiteSpace: "nowrap" }}
                            >
                              Shop Department &nbsp;
                              <i className="fa fa-angle-down" />
                            </span>
                            <div className="department-links-body">
                              <ul className="shop-department-list">
                                {mainCategories &&
                                  mainCategories.map((item, index) =>
                                    item.show === true ? (
                                      <li key={index}>
                                        <Link to={`/category/${item.slug}`}>
                                          {item.name}
                                        </Link>
                                      </li>
                                    ) : (
                                      <Fragment></Fragment>
                                    )
                                  )}
                              </ul>
                            </div>
                          </div>
                        </li>
                      </div>
                      <li
                        className="w-100 small-p0 px-0 stickySearchBar"
                        style={{
                          maxWidth: "656px",
                          margin: "0 auto",
                          position: "relative",
                        }}
                      >
                        <div className="relative">
                          <form
                            onSubmit={(e) => {
                              e.preventDefault();
                              this.props.history.push(
                                `/search/${this.state.query}`
                              );
                              let rows = [];
                              var arr = getRecentsearch();
                              if (arr) {
                                if (arr.length > 4) {
                                  arr.splice(0, 1);
                                }
                                arr.forEach((item) => rows.push(item));
                              }
                              rows.push(this.state.value);
                              // console.log(rows);

                              addRecentSearch(rows, () => {});
                            }}
                          >
                            <Autosuggest
                              multiSection={true}
                              suggestions={suggestions}
                              onSuggestionsFetchRequested={
                                this.onSuggestionsFetchRequested
                              }
                              onSuggestionsClearRequested={
                                this.onSuggestionsClearRequested
                              }
                              getSuggestionValue={getSuggestionValue}
                              renderSuggestion={renderSuggestion}
                              renderSectionTitle={renderSectionTitle}
                              getSectionSuggestions={getSectionSuggestions}
                              onSuggestionSelected={this.onSuggestionSelected}
                              inputProps={inputProps}
                              className="search-input"
                              id="search-top"
                              maxLength={11}
                              /*  onKeyDown={this.keyPress} */
                            />
                            {this.state.close === true &&
                            this.state.value !== "" ? (
                              <span
                                onMouseEnter={() =>
                                  this.setState({ hover: true })
                                }
                                onMouseLeave={() =>
                                  this.setState({ hover: false })
                                }
                                className="sm-top-search-icon endButton"
                                id="closeButton"
                                style={{ right: "60px" }}
                                onClick={this.clearSearch}
                              >
                                <i className="fa fa-times" />
                              </span>
                            ) : null}
                            {this.state.bar === false ? (
                              <button
                                type="button"
                                id="startButton"
                                className="search-button"
                                style={{
                                  position: "absolute",
                                  top: "5px",
                                  zIndex: 1,
                                  left: "0px",
                                  pointerEvents: "none",
                                  fontSize: "16px",
                                  border: "none",
                                  background: "none",
                                  color: "#8d8a90",
                                }}
                              >
                                <svg
                                  focusable="false"
                                  viewBox="0 0 28 28"
                                  class="navIcon"
                                  role="img"
                                  data-hb-id="pl-icon"
                                >
                                  <title>Clear Search</title>
                                  <path d="M23.35 22.65l-5.71-5.72a7.52 7.52 0 10-.71.71l5.72 5.71a.48.48 0 00.7 0 .48.48 0 000-.7zM5.5 12a6.5 6.5 0 116.5 6.5A6.51 6.51 0 015.5 12z"></path>
                                </svg>
                              </button>
                            ) : null}

                            {this.state.bar ? (
                              <button
                                onMouseEnter={() =>
                                  this.setState({ hover: true })
                                }
                                onMouseLeave={() =>
                                  this.setState({ hover: false })
                                }
                                type="submit"
                                /*   id="endButton"
                          className="search-button endButton" */

                                style={{
                                  position: "absolute",
                                  top: "0px",
                                  borderTopRightRadius: "8px",
                                  borderBottomRightRadius: "8px",
                                  zIndex: 0,
                                  right: "0px",
                                  color: "#ffffff",
                                  padding: "5px 10px",
                                  height: "100%",
                                  fontSize: "18px",
                                  border: "none",
                                  cursor: "pointer",
                                  background: "#17a2b8",
                                }}
                                /*   onClick={() => {
                            this.props.history.push(
                              `/search/${this.state.query}`
                            );
                          }} */
                              >
                                <i className="fa fa-search"></i>
                              </button>
                            ) : null}
                          </form>
                        </div>
                        {this.getBaar(
                          this.state.value,
                          this.state.bar,
                          this.state.hover
                        )}
                      </li>
                    </ul>
                    <ul className="first-nav-list shrink-0 pt-8p navIcons-smallScreen">
                      <li className="linkOutline-on-focus d-stick-none color-error mr-auto fNav-margin px-0 lg-screen">
                        <Link className="linkOutline-on-focus" to="/daily-sale">
                          Sale
                        </Link>
                      </li>

                      <li
                        className="c-pointer lg-screen  myaccount-dropdown-li d-stick-none d-flex align-center px-0 fNav-margin"
                        onMouseEnter={this.addBoxShadow}
                        onMouseLeave={this.remBoxShadow}
                      >
                        <span>
                          <svg
                            focusable="false"
                            viewBox="0 0 28 28"
                            class="navIcon"
                            aria-hidden="true"
                            data-hb-id="pl-icon"
                          >
                            <path d="M14 4.5a9.5 9.5 0 109.5 9.5A9.51 9.51 0 0014 4.5zM9.26 21.05v-2.17a3.37 3.37 0 013.36-3.36h2.74a3.37 3.37 0 013.36 3.36v2.19a8.47 8.47 0 01-9.48 0zM14 14.5a2.5 2.5 0 112.5-2.5 2.5 2.5 0 01-2.5 2.5zm5.73 5.76v-1.38a4.37 4.37 0 00-3.44-4.26A3.45 3.45 0 0017.5 12a3.5 3.5 0 00-7 0 3.45 3.45 0 001.21 2.62 4.37 4.37 0 00-3.44 4.26v1.38a8.5 8.5 0 1111.46 0z"></path>
                          </svg>
                        </span>
                        {isAuth ? (
                          <Link
                            to="/dashboard"
                            className="d-flex align-items-center linkOutline-on-focus"
                            onClick={this.hideUserPopup}
                          >
                            <div className="mr-txt d-flex r-none flex-column font-small ">
                              <span className="font-small">
                                My Account &amp; Orders
                              </span>
                              <span className="login-statue">Welcome</span>
                            </div>
                          </Link>
                        ) : (
                          <Link
                            to={"/login"}
                            className="mr-txt d-flex r-none flex-column font-small "
                          >
                            <span className="font-small">
                              My Account &amp; Orders
                            </span>
                            <span className="login-statue">Sign In</span>
                          </Link>
                        )}

                        {this.state.userPopup ? (
                          <ul className="myaccount-dropdown-body">
                            <p className="myaccount-dropdown-p">Welcome</p>
                            <hr />
                            <li>
                              <div className="myaccBodyRow">
                                <div className="myAcc-drpIcons">
                                  <svg
                                    style={{
                                      fill: "currentColor",
                                      width: "28px",
                                      height: "28px",
                                    }}
                                    focusable="false"
                                    viewBox="0 0 28 28"
                                    class="pl-BaseIcon MyAccountLinkCard-icon MyAccountLinkCard-icon--account"
                                    role="img"
                                    aria-label="My Account"
                                    data-hb-id="pl-icon"
                                  >
                                    <title>My Account</title>
                                    <path d="M14 5a9 9 0 100 18 9 9 0 000-18zm-3.65 15v-1.71a2.43 2.43 0 012.43-2.42h2.44a2.43 2.43 0 012.43 2.42V20a6.93 6.93 0 01-7.3 0zM14 13.51a1.29 1.29 0 110-2.58 1.29 1.29 0 010 2.58zm5.63 4.63a4.41 4.41 0 00-3-4 3.32 3.32 0 00.62-1.91 3.29 3.29 0 00-6.58 0 3.32 3.32 0 00.62 1.91 4.41 4.41 0 00-3 4A6.92 6.92 0 017 14a7 7 0 0114 0 6.92 6.92 0 01-1.37 4.14z"></path>
                                  </svg>
                                </div>
                                <div className="myAccText f1">
                                  {isAuth ? (
                                    <>
                                      <Link
                                        onClick={this.hideUserPopup}
                                        className="d-block w-100"
                                        to={"/dashboard"}
                                      >
                                        My Account
                                      </Link>
                                      <span
                                        className="d-block"
                                        style={{ fontSize: "14px" }}
                                      >
                                        {user && user.email}
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      <Link
                                        onClick={this.hideUserPopup}
                                        className="d-block w-100"
                                        to={"/login"}
                                      >
                                        My Account
                                      </Link>
                                    </>
                                  )}
                                </div>
                              </div>
                            </li>
                            <li>
                              <div className="myaccBodyRow">
                                <div className="myAcc-drpIcons">
                                  <svg
                                    style={{
                                      fill: "currentColor",
                                      width: "28px",
                                      height: "28px",
                                    }}
                                    focusable="false"
                                    viewBox="0 0 28 28"
                                    class="pl-BaseIcon MyAccountLinkCard-icon MyAccountLinkCard-icon--header-my-orders"
                                    role="img"
                                    aria-label="My Orders"
                                    data-hb-id="pl-icon"
                                  >
                                    <title>My Orders</title>
                                    <path d="M23.46 6.74a1 1 0 00-1.06-.24l-7 2.63a.93.93 0 00-.46.39 1 1 0 000-.78l-1.75-3.5a1 1 0 00-1.24-.49l-7 2.63a1 1 0 00-.63.62 1 1 0 000 .81L6 12.05v7.64a1 1 0 00.65.93l7 2.63a1.09 1.09 0 00.36.06 1 1 0 00.53-.14l6.84-2.55a1 1 0 00.65-.93V12l1.68-4.2a1 1 0 00-.25-1.06zm-6.95 4.1L21 9.17 20.24 11l-4.47 1.68zm-2.16-.72a.92.92 0 00.44-.36l-1.36 3.4-3.58-1.35zm-2.59-3.18l.85 1.7-5.12 1.92-.85-1.7zM13 20.88L8 19v-5.74l5 1.87zm2 0v-5.75l5-1.87V19z"></path>
                                    <path fill="none" d="M0 0h28v28H0z"></path>
                                  </svg>
                                </div>
                                <div className="myAccText f1">
                                  {isAuth ? (
                                    <Link
                                      onClick={this.hideUserPopup}
                                      className="d-block w-100"
                                      to={"/my-orders"}
                                    >
                                      My Orders
                                    </Link>
                                  ) : (
                                    <Link
                                      onClick={this.hideUserPopup}
                                      className="d-block w-100"
                                      to={"/login"}
                                    >
                                      My Orders
                                    </Link>
                                  )}
                                </div>
                              </div>
                            </li>
                            <hr />
                            <li>
                              <div className="myaccBodyRow">
                                <div className="myAcc-drpIcons">
                                  <svg
                                    style={{
                                      fill: "currentColor",
                                      width: "28px",
                                      height: "28px",
                                    }}
                                    focusable="false"
                                    viewBox="0 0 28 28"
                                    class="pl-BaseIcon MyAccountLinkCard-icon MyAccountLinkCard-icon--header-recently-viewed"
                                    role="img"
                                    aria-label="Recently Viewed"
                                    data-hb-id="pl-icon"
                                  >
                                    <title>Recently Viewed</title>
                                    <path d="M8.16 20.65a1.38 1.38 0 01-.6-.2A9.12 9.12 0 014 14.55a9.26 9.26 0 011.7-6.7 9.16 9.16 0 015.9-3.6 8.82 8.82 0 016.7 1.6 9 9 0 013.7 7.2 1 1 0 01-.88 1H21a.94.94 0 01-1-.88.24.24 0 010-.12 7.09 7.09 0 00-7.21-7 6.54 6.54 0 00-.89.07 7.46 7.46 0 00-4.6 2.9A7 7 0 006 14.25a7.17 7.17 0 002.8 4.6 1.09 1.09 0 01.2 1.4 1.26 1.26 0 01-.84.4z"></path>
                                    <path d="M12.86 14.15h-2.7a1 1 0 010-2h1.7v-3.4a1 1 0 012 0v4.4a1 1 0 01-.88 1zm4.7 10a8 8 0 01-6.7-4.1c-.1-.3-.2-.6 0-.8 1-2.5 4.3-4.2 6.7-4.2a7.83 7.83 0 016.6 4.1.75.75 0 010 .9 8 8 0 01-6.6 4.1zm-4.7-4.7a5.9 5.9 0 004.6 2.7 6 6 0 004.6-2.6 5.91 5.91 0 00-4.6-2.6 6.09 6.09 0 00-4.6 2.5z"></path>
                                    <circle
                                      cx="17.46"
                                      cy="19.55"
                                      r="1.4"
                                    ></circle>
                                  </svg>
                                </div>
                                <div className="myAccText f1">
                                  <Link
                                    onClick={this.hideUserPopup}
                                    className="d-block w-100"
                                    to={"/recently-view"}
                                  >
                                    Recently Viewed
                                  </Link>
                                </div>
                              </div>
                            </li>
                            <hr />
                            <li>
                              <div className="myaccBodyRow">
                                <div className="myAcc-drpIcons">
                                  <svg
                                    style={{
                                      fill: "currentColor",
                                      width: "28px",
                                      height: "28px",
                                    }}
                                    focusable="false"
                                    viewBox="0 0 28 28"
                                    class="pl-BaseIcon MyAccountLinkCard-icon MyAccountLinkCard-icon--header-lists-heart"
                                    role="img"
                                    aria-label="Lists &amp; Registry"
                                    data-hb-id="pl-icon"
                                  >
                                    <title>Lists &amp; Registry</title>
                                    <path d="M14 21.74a1 1 0 01-.7-.28l-6.82-6.71a4.93 4.93 0 010-7 5.08 5.08 0 017.1 0l.42.41.42-.42a5.09 5.09 0 017.1 0 4.93 4.93 0 010 7l-6.82 6.72a1 1 0 01-.7.28zM10 8.26a3.06 3.06 0 00-2.15.87 2.93 2.93 0 000 4.14l6.12 6 6.12-6a2.93 2.93 0 000-4.14 3.08 3.08 0 00-4.29 0l-1.13 1.1a1 1 0 01-1.4 0l-1.09-1.09A3 3 0 0010 8.26z"></path>
                                    <path
                                      fill="none"
                                      d="M10 8.26a3.06 3.06 0 00-2.15.87 2.93 2.93 0 000 4.14l6.12 6 6.12-6a2.93 2.93 0 000-4.14 3.08 3.08 0 00-4.29 0l-1.13 1.1a1 1 0 01-1.4 0l-1.09-1.09A3 3 0 0010 8.26z"
                                    ></path>
                                  </svg>
                                </div>
                                <div className="myAccText f1">
                                  {isAuth ? (
                                    <Link
                                      onClick={this.hideUserPopup}
                                      className="d-block w-100"
                                      to={"/wishlist"}
                                    >
                                      Lists
                                    </Link>
                                  ) : (
                                    <Link
                                      onClick={this.hideUserPopup}
                                      className="d-block w-100"
                                      to={"/login"}
                                    >
                                      Lists
                                    </Link>
                                  )}
                                </div>
                              </div>
                            </li>
                            <hr />
                            <li>
                              <div className=" myaccBodyRow">
                                <div className="myAcc-drpIcons">
                                  <svg
                                    style={{
                                      fill: "currentColor",
                                      height: "28px",
                                      width: "28px",
                                    }}
                                    focusable="false"
                                    viewBox="0 0 28 28"
                                    class="pl-BaseIcon MyAccountLinkCard-icon MyAccountLinkCard-icon--credit-card"
                                    role="img"
                                    aria-label="sundial Credit Card"
                                    data-hb-id="pl-icon"
                                  >
                                    <title>sundial Credit Card</title>
                                    <path d="M21.34 8H7a2 2 0 00-2 2v9a2 2 0 002 2h14.34a2 2 0 002-2v-9a2 2 0 00-2-2zm0 2v1.87H7V10h14.34zM7 19v-5.13h14.34V19H7z"></path>
                                  </svg>
                                </div>
                                <div className="myAccText f1">
                                  {isAuth ? (
                                    <Link
                                      onClick={this.hideUserPopup}
                                      className="d-block w-100"
                                      to={"/membership-packages"}
                                    >
                                      Sundial Membership
                                    </Link>
                                  ) : (
                                    <Link
                                      onClick={this.hideUserPopup}
                                      className="d-block w-100"
                                      to={"/login"}
                                    >
                                      Sundial Membership
                                    </Link>
                                  )}
                                </div>
                              </div>
                            </li>
                            <li>
                              <div className="row myaccBodyRow">
                                <div className="myAcc-drpIcons">
                                  <svg
                                    style={{
                                      fill: "currentColor",
                                      width: "28px",
                                      height: "28px",
                                    }}
                                    focusable="false"
                                    viewBox="0 0 28 28"
                                    class="pl-BaseIcon MyAccountLinkCard-icon MyAccountLinkCard-icon--info"
                                    role="img"
                                    aria-label="Help &amp; Contact"
                                    data-hb-id="pl-icon"
                                  >
                                    <title>Help &amp; Contact</title>
                                    <path d="M14 12.4a.94.94 0 00-1 .88v5.12a1 1 0 002 0v-5a.94.94 0 00-.88-1zm0-3.2a1.1 1.1 0 101.1 1.1A1.11 1.11 0 0014 9.2z"></path>
                                    <path d="M14 5a9 9 0 109 9 9 9 0 00-9-9zm0 16a7 7 0 117-7 7 7 0 01-7 7z"></path>
                                  </svg>
                                </div>
                                <div className="myAccText f1">
                                  {isAuth ? (
                                    <Link
                                      onClick={this.hideUserPopup}
                                      className="d-block w-100"
                                      to={"/customer-service"}
                                    >
                                      Help &amp; Contact
                                    </Link>
                                  ) : (
                                    <Link
                                      onClick={this.hideUserPopup}
                                      className="d-block w-100"
                                      to={"/customer-service"}
                                    >
                                      Help &amp; Contact
                                    </Link>
                                  )}
                                </div>
                              </div>
                            </li>
                            <br />
                            <li>
                              {isAuth ? (
                                <Link
                                  className="btn btn-primary sign-in-creat auth-bg"
                                  to="#!"
                                  onClick={() => {
                                    this.props.logout();
                                  }}
                                >
                                  Logout
                                </Link>
                              ) : (
                                <Link
                                  to={"/login"}
                                  onClick={this.hideUserPopup}
                                  className="btn btn-primary sign-in-creat auth-bg"
                                >
                                  Sign in or create and account
                                </Link>
                              )}
                            </li>
                          </ul>
                        ) : null}
                      </li>
                      {/* END OF myaccount-dropdown-li*/}
                      {/* LIST DROPDOWN MARKUP */}

                      <li
                        className="list-dropdown-li lg-screen d-stick-none px-0 fNav-margin"
                        onMouseEnter={this.showWishBox}
                        onMouseLeave={this.hideWishBox}
                      >
                        <Link
                          to={"/wishlist"}
                          className="linkOutline-on-focus  d-flex align-items-center mr-txt"
                        >
                          <svg
                            focusable="false"
                            viewBox="0 0 28 28"
                            data-enzyme-id="ListsContent-icon"
                            className="navIcon"
                            role="img"
                            aria-label="Lists"
                            data-hb-id="pl-icon"
                          >
                            <title>Lists</title>
                            <path d="M14 22.5a.51.51 0 01-.36-.15l-7.85-8.14a5.34 5.34 0 01-1.29-3.45A5.2 5.2 0 019.63 5.5 5.08 5.08 0 0114 8.05a5.08 5.08 0 014.37-2.55 5.2 5.2 0 015.13 5.26 5.33 5.33 0 01-1.26 3.42l-7.88 8.17a.51.51 0 01-.36.15zm-4.37-16a4.2 4.2 0 00-4.13 4.26 4.29 4.29 0 001 2.78l7.5 7.74 7.49-7.77a4.26 4.26 0 00-3.12-7 4.12 4.12 0 00-3.89 2.92.53.53 0 01-1 0A4.12 4.12 0 009.63 6.5z"></path>
                          </svg>
                          {/*
                            THIS SHOWS THE NUMBER OF ITEMS ADDED IN WISH LIST
                            UNCOMMENT IF NEEDED
                            💗💗💗💗💗 
                            <span
                            id="cart-items"
                            className={`count-badge ${
                              localStorage.getItem("wishlist") &&
                              JSON.parse(localStorage.getItem("wishlist"))
                                .length === 0 &&
                              "count-zero"
                            }`}
                          >
                            {localStorage.getItem("wishlist") &&
                            JSON.parse(localStorage.getItem("wishlist"))
                              .length > 0
                              ? JSON.parse(localStorage.getItem("wishlist"))
                                  .length
                              : null}
                          </span> */}
                          <span className="r-none ml-2">Lists & Registry</span>
                        </Link>
                        <div className="list-card">
                          <Link to={"/wishlist"}>
                            {this.state.wishPopup ? (
                              <div className="list-card-body">
                                <div
                                  className="list-card-1"
                                  style={{ marginRight: "12px" }}
                                >
                                  <div className="list-card-content">
                                    <LazyLoadImage
                                      effect="blur"
                                      src="https://sundialinsider.s3.us-east-2.amazonaws.com/577wish1.jpg"
                                      width="100%"
                                      alt=""
                                    />
                                    <p className="list-card-name">WishList</p>
                                    <p
                                      style={{
                                        color: "rgb(109, 109, 109)",
                                        textAlign: "center",
                                        fontSize: "14px",
                                        padding: "4px 12px",
                                      }}
                                    >
                                      Keep track of items that catch your eye by
                                      saving them to your Wishlist
                                    </p>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                          </Link>
                        </div>
                      </li>

                      {/* LIST DROPDOWN MARKUP */}

                      <li
                        id="first-shoping-cart"
                        className=" cartIconNav lg-screen myaccount-dropdown-li px-0 fNav-margin"
                        onMouseEnter={this.showCartPopup}
                        onMouseLeave={this.hideCartPopup}
                      >
                        <Link
                          to={"/shopping-cart"}
                          className="linkOutline-on-focus d-flex align-items-center"
                        >
                          <svg
                            focusable="false"
                            viewBox="0 0 28 28"
                            class="navIcon"
                            aria-hidden="true"
                            data-hb-id="pl-icon"
                          >
                            <path d="M21 15.54a.51.51 0 00.49-.38l2-8a.51.51 0 00-.1-.43.49.49 0 00-.39-.19H8.28L8 4.9a.51.51 0 00-.49-.4H5a.5.5 0 000 1h2.05L9 15l-2.36 4.74a.53.53 0 000 .49.5.5 0 00.42.23H21a.5.5 0 00.5-.5.5.5 0 00-.5-.5H7.89l1.92-3.92zm1.34-8l-1.73 7H9.92l-1.43-7zM10 21a1 1 0 101 1 1 1 0 00-1-1zM18 21a1 1 0 101 1 1 1 0 00-1-1z"></path>
                          </svg>
                          <span
                            id="cart-items"
                            className={`count-badge ${
                              localStorage.getItem("cart") &&
                              JSON.parse(localStorage.getItem("cart"))
                                .length === 0 &&
                              "count-zero"
                            }`}
                          >
                            {localStorage.getItem("cart") &&
                            JSON.parse(localStorage.getItem("cart")).length > 0
                              ? JSON.parse(localStorage.getItem("cart")).length
                              : null}
                          </span>
                          <span className="r-none d-stick-none mr-txt">
                            Cart
                          </span>
                        </Link>
                        {this.state.cartPopup ? (
                          <ul className="myaccount-dropdown-body cart-dropdown-li ">
                            <div className="d-flex justify-content-between">
                              <div className="d-flex">
                                <h4 className="myaccount-dropdown-h4">Cart</h4>
                                <p className="myaccount-dropdown-p">
                                  {localStorage.getItem("cart") &&
                                  JSON.parse(localStorage.getItem("cart"))
                                    .length > 0
                                    ? JSON.parse(localStorage.getItem("cart"))
                                        .length + " Item"
                                    : null}
                                </p>
                              </div>
                              <h4 className="myaccount-dropdown-h4 pr-2">
                                {this.state.total && this.state.total !== 0
                                  ? "$" + Number(this.state.total).toFixed(2)
                                  : null}
                              </h4>
                            </div>
                            <hr />
                            <div className="my-cart-main">
                              <div className="cart-body">
                                {localStorage.getItem("cart") &&
                                JSON.parse(localStorage.getItem("cart"))
                                  .length > 0
                                  ? JSON.parse(
                                      localStorage.getItem("cart")
                                    ).map((cartItem, indexItem) => (
                                      <div
                                        className="row relative"
                                        key={indexItem}
                                        style={{
                                          borderBottom: "1px solid #e0e0e0",
                                          paddingTop: "10px",
                                        }}
                                      >
                                        <span
                                          className="cartCross"
                                          onClick={() =>
                                            this.removeCartItem(indexItem)
                                          }
                                        >
                                          <i className="fa fa-times" />{" "}
                                        </span>
                                        <div className="col-md-4 col-sm-6">
                                          <span
                                            className="cartCross"
                                            onClick={() =>
                                              this.removeCartItem(indexItem)
                                            }
                                          ></span>
                                          <div className="myCart-img">
                                            <LazyLoadImage
                                              effect="blur"
                                              src={
                                                cartItem &&
                                                cartItem.item.images &&
                                                cartItem.item.images[0]
                                              }
                                              width="100%"
                                              alt=""
                                              height="80px"
                                            />
                                          </div>
                                        </div>
                                        <div className="col-md-8 col-sm-6">
                                          <div className="myCart-img-details">
                                            <p className="m-0">
                                              <Link
                                                to={`/product/${cartItem.item.slug}`}
                                              >
                                                {cartItem &&
                                                  cartItem.item.title}
                                              </Link>
                                            </p>
                                            <p className="m-0">
                                              {cartItem && cartItem.modalNumber}
                                            </p>
                                            <p className="m-0">
                                              Quantity:{" "}
                                              {cartItem && cartItem.quantity}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    ))
                                  : null}
                              </div>
                            </div>
                            <li>
                              {localStorage.getItem("cart") &&
                              JSON.parse(localStorage.getItem("cart")).length >
                                0 ? (
                                <button className="btn btn-primary sign-in-creat auth-bg">
                                  <Link to={"/shopping-cart"}>Review Cart</Link>
                                </button>
                              ) : (
                                <div className="text-center">
                                  <b>Your shopping cart is empty.</b>
                                  <p>
                                    Let's get it rolling. Start saving with{" "}
                                    <Link to={"/dailysale"}>Daily Sales</Link>
                                  </p>{" "}
                                </div>
                              )}
                            </li>
                          </ul>
                        ) : null}
                      </li>
                      <li className="myaccount-dropdown-li md-screen  sm-toggle-user-popup">
                        {isAuth ? (
                          <Link to={"/dashboard"}>
                            {" "}
                            <img
                              class="navIcon"
                              src="/assets/images/user.svg"
                              alt=""
                            />
                          </Link>
                        ) : (
                          <Link to={"/login"}>
                            {" "}
                            <img
                              className="navIcon"
                              src="/assets/images/user.svg"
                              alt=""
                            />
                          </Link>
                        )}
                        <ul className="myaccount-dropdown-body small-user-popup">
                          <p className="myaccount-dropdown-p">Welcome</p>
                          <hr />
                          <li>
                            <div className="myaccBodyRow">
                              <div className="myAcc-drpIcons">
                                <svg
                                  style={{
                                    fill: "currentColor",
                                    width: "28px",
                                    height: "28px",
                                  }}
                                  focusable="false"
                                  viewBox="0 0 28 28"
                                  class="pl-BaseIcon MyAccountLinkCard-icon MyAccountLinkCard-icon--account"
                                  role="img"
                                  aria-label="My Account"
                                  data-hb-id="pl-icon"
                                >
                                  <title>My Account</title>
                                  <path d="M14 5a9 9 0 100 18 9 9 0 000-18zm-3.65 15v-1.71a2.43 2.43 0 012.43-2.42h2.44a2.43 2.43 0 012.43 2.42V20a6.93 6.93 0 01-7.3 0zM14 13.51a1.29 1.29 0 110-2.58 1.29 1.29 0 010 2.58zm5.63 4.63a4.41 4.41 0 00-3-4 3.32 3.32 0 00.62-1.91 3.29 3.29 0 00-6.58 0 3.32 3.32 0 00.62 1.91 4.41 4.41 0 00-3 4A6.92 6.92 0 017 14a7 7 0 0114 0 6.92 6.92 0 01-1.37 4.14z"></path>
                                </svg>
                              </div>
                              <div className="myAccText f1">
                                {isAuth ? (
                                  <>
                                    <Link
                                      onClick={this.hideUserPopup}
                                      className="d-block w-100"
                                      to={"/dashboard"}
                                    >
                                      My Account
                                    </Link>
                                    <span
                                      className="d-block"
                                      style={{ fontSize: "14px" }}
                                    >
                                      {user && user.email}
                                    </span>
                                  </>
                                ) : (
                                  <>
                                    <Link
                                      onClick={this.hideUserPopup}
                                      className="d-block w-100"
                                      to={"/login"}
                                    >
                                      My Account
                                    </Link>
                                  </>
                                )}
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className="myaccBodyRow">
                              <div className="myAcc-drpIcons">
                                <svg
                                  style={{
                                    fill: "currentColor",
                                    width: "28px",
                                    height: "28px",
                                  }}
                                  focusable="false"
                                  viewBox="0 0 28 28"
                                  class="pl-BaseIcon MyAccountLinkCard-icon MyAccountLinkCard-icon--header-my-orders"
                                  role="img"
                                  aria-label="My Orders"
                                  data-hb-id="pl-icon"
                                >
                                  <title>My Orders</title>
                                  <path d="M23.46 6.74a1 1 0 00-1.06-.24l-7 2.63a.93.93 0 00-.46.39 1 1 0 000-.78l-1.75-3.5a1 1 0 00-1.24-.49l-7 2.63a1 1 0 00-.63.62 1 1 0 000 .81L6 12.05v7.64a1 1 0 00.65.93l7 2.63a1.09 1.09 0 00.36.06 1 1 0 00.53-.14l6.84-2.55a1 1 0 00.65-.93V12l1.68-4.2a1 1 0 00-.25-1.06zm-6.95 4.1L21 9.17 20.24 11l-4.47 1.68zm-2.16-.72a.92.92 0 00.44-.36l-1.36 3.4-3.58-1.35zm-2.59-3.18l.85 1.7-5.12 1.92-.85-1.7zM13 20.88L8 19v-5.74l5 1.87zm2 0v-5.75l5-1.87V19z"></path>
                                  <path fill="none" d="M0 0h28v28H0z"></path>
                                </svg>
                              </div>
                              <div className="myAccText f1">
                                {isAuth ? (
                                  <Link
                                    onClick={this.hideUserPopup}
                                    className="d-block w-100"
                                    to={"/my-orders"}
                                  >
                                    My Orders
                                  </Link>
                                ) : (
                                  <Link
                                    onClick={this.hideUserPopup}
                                    className="d-block w-100"
                                    to={"/login"}
                                  >
                                    My Orders
                                  </Link>
                                )}
                              </div>
                            </div>
                          </li>
                          <hr />
                          <li>
                            <div className="myaccBodyRow">
                              <div className="myAcc-drpIcons">
                                <svg
                                  style={{
                                    fill: "currentColor",
                                    width: "28px",
                                    height: "28px",
                                  }}
                                  focusable="false"
                                  viewBox="0 0 28 28"
                                  class="pl-BaseIcon MyAccountLinkCard-icon MyAccountLinkCard-icon--header-recently-viewed"
                                  role="img"
                                  aria-label="Recently Viewed"
                                  data-hb-id="pl-icon"
                                >
                                  <title>Recently Viewed</title>
                                  <path d="M8.16 20.65a1.38 1.38 0 01-.6-.2A9.12 9.12 0 014 14.55a9.26 9.26 0 011.7-6.7 9.16 9.16 0 015.9-3.6 8.82 8.82 0 016.7 1.6 9 9 0 013.7 7.2 1 1 0 01-.88 1H21a.94.94 0 01-1-.88.24.24 0 010-.12 7.09 7.09 0 00-7.21-7 6.54 6.54 0 00-.89.07 7.46 7.46 0 00-4.6 2.9A7 7 0 006 14.25a7.17 7.17 0 002.8 4.6 1.09 1.09 0 01.2 1.4 1.26 1.26 0 01-.84.4z"></path>
                                  <path d="M12.86 14.15h-2.7a1 1 0 010-2h1.7v-3.4a1 1 0 012 0v4.4a1 1 0 01-.88 1zm4.7 10a8 8 0 01-6.7-4.1c-.1-.3-.2-.6 0-.8 1-2.5 4.3-4.2 6.7-4.2a7.83 7.83 0 016.6 4.1.75.75 0 010 .9 8 8 0 01-6.6 4.1zm-4.7-4.7a5.9 5.9 0 004.6 2.7 6 6 0 004.6-2.6 5.91 5.91 0 00-4.6-2.6 6.09 6.09 0 00-4.6 2.5z"></path>
                                  <circle
                                    cx="17.46"
                                    cy="19.55"
                                    r="1.4"
                                  ></circle>
                                </svg>
                              </div>
                              <div className="myAccText f1">
                                <Link
                                  onClick={this.hideUserPopup}
                                  className="d-block w-100"
                                  to={"/recently-view"}
                                >
                                  Recently Viewed
                                </Link>
                              </div>
                            </div>
                          </li>
                          <hr />
                          <li>
                            <div className="myaccBodyRow">
                              <div className="myAcc-drpIcons">
                                <svg
                                  style={{
                                    fill: "currentColor",
                                    width: "28px",
                                    height: "28px",
                                  }}
                                  focusable="false"
                                  viewBox="0 0 28 28"
                                  class="pl-BaseIcon MyAccountLinkCard-icon MyAccountLinkCard-icon--header-lists-heart"
                                  role="img"
                                  aria-label="Lists &amp; Registry"
                                  data-hb-id="pl-icon"
                                >
                                  <title>Lists &amp; Registry</title>
                                  <path d="M14 21.74a1 1 0 01-.7-.28l-6.82-6.71a4.93 4.93 0 010-7 5.08 5.08 0 017.1 0l.42.41.42-.42a5.09 5.09 0 017.1 0 4.93 4.93 0 010 7l-6.82 6.72a1 1 0 01-.7.28zM10 8.26a3.06 3.06 0 00-2.15.87 2.93 2.93 0 000 4.14l6.12 6 6.12-6a2.93 2.93 0 000-4.14 3.08 3.08 0 00-4.29 0l-1.13 1.1a1 1 0 01-1.4 0l-1.09-1.09A3 3 0 0010 8.26z"></path>
                                  <path
                                    fill="none"
                                    d="M10 8.26a3.06 3.06 0 00-2.15.87 2.93 2.93 0 000 4.14l6.12 6 6.12-6a2.93 2.93 0 000-4.14 3.08 3.08 0 00-4.29 0l-1.13 1.1a1 1 0 01-1.4 0l-1.09-1.09A3 3 0 0010 8.26z"
                                  ></path>
                                </svg>
                              </div>
                              <div className="myAccText f1">
                                {isAuth ? (
                                  <Link
                                    onClick={this.hideUserPopup}
                                    className="d-block w-100"
                                    to={"/wishlist"}
                                  >
                                    Lists
                                  </Link>
                                ) : (
                                  <Link
                                    onClick={this.hideUserPopup}
                                    className="d-block w-100"
                                    to={"/login"}
                                  >
                                    Lists
                                  </Link>
                                )}
                              </div>
                            </div>
                          </li>
                          <hr />
                          <li>
                            <div className=" myaccBodyRow">
                              <div className="myAcc-drpIcons">
                                <svg
                                  style={{
                                    fill: "currentColor",
                                    height: "28px",
                                    width: "28px",
                                  }}
                                  focusable="false"
                                  viewBox="0 0 28 28"
                                  class="pl-BaseIcon MyAccountLinkCard-icon MyAccountLinkCard-icon--credit-card"
                                  role="img"
                                  aria-label="sundial Credit Card"
                                  data-hb-id="pl-icon"
                                >
                                  <title>sundial Credit Card</title>
                                  <path d="M21.34 8H7a2 2 0 00-2 2v9a2 2 0 002 2h14.34a2 2 0 002-2v-9a2 2 0 00-2-2zm0 2v1.87H7V10h14.34zM7 19v-5.13h14.34V19H7z"></path>
                                </svg>
                              </div>
                              <div className="myAccText f1">
                                {isAuth ? (
                                  <Link
                                    onClick={this.hideUserPopup}
                                    className="d-block w-100"
                                    to={"/membership-packages"}
                                  >
                                    Sundial Membership
                                  </Link>
                                ) : (
                                  <Link
                                    onClick={this.hideUserPopup}
                                    className="d-block w-100"
                                    to={"/login"}
                                  >
                                    Sundial Membership
                                  </Link>
                                )}
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className="row myaccBodyRow">
                              <div className="myAcc-drpIcons">
                                <svg
                                  style={{
                                    fill: "currentColor",
                                    width: "28px",
                                    height: "28px",
                                  }}
                                  focusable="false"
                                  viewBox="0 0 28 28"
                                  class="pl-BaseIcon MyAccountLinkCard-icon MyAccountLinkCard-icon--info"
                                  role="img"
                                  aria-label="Help &amp; Contact"
                                  data-hb-id="pl-icon"
                                >
                                  <title>Help &amp; Contact</title>
                                  <path d="M14 12.4a.94.94 0 00-1 .88v5.12a1 1 0 002 0v-5a.94.94 0 00-.88-1zm0-3.2a1.1 1.1 0 101.1 1.1A1.11 1.11 0 0014 9.2z"></path>
                                  <path d="M14 5a9 9 0 109 9 9 9 0 00-9-9zm0 16a7 7 0 117-7 7 7 0 01-7 7z"></path>
                                </svg>
                              </div>
                              <div className="myAccText f1">
                                {isAuth ? (
                                  <Link
                                    onClick={this.hideUserPopup}
                                    className="d-block w-100"
                                    to={"/customer-service"}
                                  >
                                    Help &amp; Contact
                                  </Link>
                                ) : (
                                  <Link
                                    onClick={this.hideUserPopup}
                                    className="d-block w-100"
                                    to={"/customer-service"}
                                  >
                                    Help &amp; Contact
                                  </Link>
                                )}
                              </div>
                            </div>
                          </li>
                          <br />
                          <li>
                            {isAuth ? (
                              <Link
                                className="btn btn-primary sign-in-creat auth-bg"
                                to="#!"
                                onClick={() => {
                                  this.props.logout();
                                }}
                              >
                                Logout
                              </Link>
                            ) : (
                              <Link
                                to={"/login"}
                                onClick={this.hideUserPopup}
                                className="btn btn-primary sign-in-creat auth-bg"
                              >
                                Sign in or create and account
                              </Link>
                            )}
                          </li>
                        </ul>
                      </li>
                      {/* END OF myaccount-dropdown-li*/}
                      {/* LIST DROPDOWN MARKUP */}
                      <li className="list-dropdown-li md-screen">
                        <Link to={"/wishlist"}>
                          <img
                            className="navIcon"
                            src="/assets/images/heart.svg"
                            alt=""
                          />
                          <span
                            id="cart-items"
                            className={`count-badge ${
                              localStorage.getItem("wishlist") &&
                              JSON.parse(localStorage.getItem("wishlist"))
                                .length === 0 &&
                              "count-zero"
                            }`}
                          >
                            {localStorage.getItem("wishlist") &&
                            JSON.parse(localStorage.getItem("wishlist"))
                              .length > 0
                              ? JSON.parse(localStorage.getItem("wishlist"))
                                  .length
                              : null}
                          </span>
                        </Link>
                      </li>
                      {/* LIST DROPDOWN MARKUP */}
                      <li
                        id="first-shoping-cart"
                        className="md-screen  relative hide-sm"
                      >
                        <Link to={"/shopping-cart"}>
                          <img
                            className="navIcon"
                            src="/assets/images/cart-icon.svg"
                            alt=""
                          />
                          <span
                            id="cart-items"
                            className={`count-badge ${
                              localStorage.getItem("cart") &&
                              JSON.parse(localStorage.getItem("cart"))
                                .length === 0 &&
                              "count-zero"
                            }`}
                          >
                            {localStorage.getItem("cart") &&
                            JSON.parse(localStorage.getItem("cart")).length > 0
                              ? JSON.parse(localStorage.getItem("cart")).length
                              : null}
                          </span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </nav>
          </div>
          {/*// END NAV BAR */}
          {/* ON SMALL SCREEN STICKY SEARCHBAR */}
          <div className="container-fluid" id="sm-top-search">
            {/*   <form onSubmit={() => {
                        this.props.history.push(
                          `/search/${this.state.query}`
                        );
                      }}>
        <span className="sm-top-input">
          <Autosuggest
            multiSection={true}
            suggestions={suggestions}
            onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
            onSuggestionsClearRequested={this.onSuggestionsClearRequested}
            getSuggestionValue={getSuggestionValue}
            renderSuggestion={renderSuggestion}
            renderSectionTitle={renderSectionTitle}
            getSectionSuggestions={getSectionSuggestions}
            inputProps={inputProps}
            className="search-input"
            id="search-top"
            onKeyDown={this.keyPress}
          />
          <span className="sm-top-search-icon" id="startButton1">
            <i className="fa fa-search" />
          </span>
          <span
            className="sm-top-search-icon endButton"
            id="closeButton"
            style={{ right: "60px" }}
            onClick={this.clearSearch}
          >
            <i className="fa fa-times" />
          </span>
          <button
            type="button"
            id="endButton1"
            className="sm-top-search-icon endButton"
            style={{
              position: "absolute",
              borderTopRightRadius: "5px",
              borderBottomRightRadius: "5px",
              zIndex: 999,
              bottom: "9.3px",
              right: "9px",
              color: "#ffffff",
              padding: "3px 10px",
              fontSize: "18px",
              border: "2px solid #17a2b8",
              background: "#17a2b8",
            }}
          onClick={() => {
              this.props.history.push(`/search/${this.state.query}`);
            }} 
          >
            <i className="fa fa-search"></i>
          </button>
        </span>
        </form> */}
          </div>
        </header>

        {/* START MEGA MENUE  */}
        <div className="mega-menue">
          <div
            className={
              this.state.boxShadow
                ? "main-mega-nav addBoxshadow"
                : "main-mega-nav "
            }
          >
            <div className="circle"></div>
            <ul className="mega-nav-list">
              {mainCategories &&
                mainCategories.map((item, index) =>
                  item.show === true ? (
                    <li
                      key={index}
                      onMouseOver={this.hovered}
                      onClick={this.CloseMegaMenu}
                      className="mega-nav-list-item circle"
                    >
                      <Link
                        to={`/category/${item.slug}`}
                        className="mega-nav-links"
                        onClick={this.megaLinkClicked}
                      >
                        {item.name}
                      </Link>
                      {this.state.megaMenueOpen ? (
                        <div
                          className="container m-container"
                          id="mega-container"
                        >
                          <div className="masonry-mega-menu">
                            {childCategories &&
                              childCategories.map((childitem, childindex) =>
                                childitem.mainCategoryId === item._id &&
                                childitem.show === true ? (
                                  <div
                                    key={childindex}
                                    className="item-mega-menu"
                                  >
                                    <div className="mega-inner">
                                      <div className="mega-column-header">
                                        <Link
                                          className="mega-column-title"
                                          to={`/category/${item.slug}`}
                                        >
                                          <h4 onClick={this.megaLinkClicked}>
                                            {childitem.name}&nbsp;
                                            <i className="fa fa-arrow-right" />
                                          </h4>
                                        </Link>
                                      </div>
                                      <div className="mega-columns">
                                        <div className="mega-column-links">
                                          <ul className="megaInner-links-list">
                                            {subCategories &&
                                              subCategories.map(
                                                (subitem, subindex) =>
                                                  subitem.categoryId ===
                                                  childitem._id ? (
                                                    <li
                                                      key={subindex}
                                                      className="megaInner-items"
                                                    >
                                                      <Link
                                                        to={`/products/${subitem.slug}/1`}
                                                        className="mega-inner-link"
                                                        onClick={
                                                          this.megaLinkClicked
                                                        }
                                                      >
                                                        {subitem.name}
                                                      </Link>
                                                    </li>
                                                  ) : null
                                              )}
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ) : null
                              )}
                          </div>
                        </div>
                      ) : null}
                    </li>
                  ) : (
                    <Fragment></Fragment>
                  )
                )}
              {/*Revonation MEGA END*/}
            </ul>
          </div>
        </div>

        {/*END MEGA MENUE  */}
      </React.Fragment>
    );
  }
}
logout.propTypes = {
  logout: PropTypes.func.isRequired,
};

getCart.propTypes = {
  getCart: PropTypes.func.isRequired,
};

cartRemove.propTypes = {
  cartRemove: PropTypes.func.isRequired,
};
currentLocation.prototype = {
  currentLocation: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  _auth: state.auth,
  _categories: state.categories,
});

export default withRouter(
  connect(mapStateToProps, { logout, getCart, cartRemove, currentLocation })(
    Header
  )
);
